import "./Eligibility.css";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";

const PropertyEligibility = ({
  steps = 1,
  title = "Apply easily",
  highlightedText = "in just 1 step",
  documentsTitle = "",
  documents = [],
  eligibilityTitle = "",
  eligibility = [],
  horizontalTable = false,
  employeeType,
  yearsOld = "years old",
  ageRange = {
    minimum: {
      value: "",
      label: "Minimum Age",
    },
  },
  income = {
    range: "RM 3,000 - RM 4,999",
    description: "of minimum monthly gross income",
  },
}) => {
  return (
    <section id="prop-eligibility" className="values section h-100">
      <Container>
        <Row className="gy-4 align-items-end">
          {documentsTitle && (
            <Col
              xl={steps == 2 ? 6 : 12}
              xs={12}
              className="d-flex justify-content-end flex-column required-documents"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <p data-aos="fade-up" className="requirements-text">
                <span>{title}</span>{" "}
                <span style={{ color: "#221AFB" }}>
                  {highlightedText.split("\n").map((text, i) => (
                    <React.Fragment key={i}>
                      {text}
                      {i === 0 && <br />}
                    </React.Fragment>
                  ))}
                </span>
              </p>

              <div
                className="d-flex flex-wrap order-xs-2 order-xl-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="docs-required-header">{documentsTitle}</div>
                <div className="docs-required-content d-flex align-items-center flex-column bottom-border">
                  {documents.map((doc, index) => (
                    <div
                      className={`row border-row ${
                        eligibilityTitle && "widthy"
                      }`}
                    >
                      {/* <div
                        key={index}
                        className={`col-md-6 ${
                          index === 0 ? "docs-subtext" : "docs-subtext-2"
                        }`}
                        style={{
                          backgroundColor: doc.backgroundColor,
                        }}
                      > */}
                      {doc.title && (
                        <div className="border-row-title">
                          {parse(doc.title)}
                        </div>
                      )}
                      {doc.content && (
                        <div className="border-row-content">
                          {parse(doc.content)}
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          )}
          {/* {eligibilityTitle && (
            <Col
              xl={steps == 2 ? 6 : 12}
              xs={12}
              className="d-flex justify-content-end flex-column"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {steps == 1 && (
                <p data-aos="fade-up" className="requirements-text">
                  <span>{title}</span>{" "}
                  <span style={{ color: "#221AFB" }}>
                    {highlightedText.split("\n").map((text, i) => (
                      <React.Fragment key={i}>
                        {text}
                        {i === 0 && <br />}
                      </React.Fragment>
                    ))}
                  </span>
                </p>
              )}

              <div
                className="d-flex flex-wrap order-xs-2 order-xl-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="docs-required-header">{eligibilityTitle}</div>
                <div
                  className={`docs-required-content d-flex align-items-center`}
                >
                  <div
                    className={`row w-100 ${
                      eligibility.length > 2 ? "flex-column" : "flex-row"
                    }`}
                  >
                    {eligibility?.map((doc, index) => (
                      <div
                        key={index}
                        className={`eligibility-subtext 
                        ${eligibility.length > 2 ? "col-12" : "col-md-6"}`}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#DCE9FF" : "#F2F4F7",
                        }}
                      >
                        {doc.title && (
                          <div
                            style={{
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "flex-start",
                              marginTop: "0",
                            }}
                          >
                            {parse(doc.title)}
                          </div>
                        )}
                        {doc.content && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              height: "80%",
                              marginLeft: "20px",
                            }}
                          >
                            {parse(doc.content)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          )} */}

          {eligibilityTitle && (
            <Col
              xl={6}
              xs={12}
              className="order-xs-1 order-xl-2 eligibility-container"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              {employeeType && (
                <div className="eligibilty-subheader text-center">
                  {employeeType}
                </div>
              )}
              <div className="docs-required-header text-start px-5">
                {eligibilityTitle}
              </div>
              {horizontalTable ? (
                <>
                  <div className="docs-required-content d-flex align-items-center flex-column bottom-border">
                    {eligibility.map((doc, index) => (
                      <div
                        className={`row border-row ${
                          eligibilityTitle && "widthy"
                        }`}
                      >
                        {doc.title && (
                          <div className="border-row-title">
                            {parse(doc.title)}
                          </div>
                        )}
                        {doc.content && (
                          <div className="border-row-content">
                            {parse(doc.content)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="eligibilty-content">
                    <div className="eligibilty-age">
                      <div className="age_border">
                        <span className="purecounter">
                          {ageRange?.minimum?.value}
                        </span>
                        <span className="eligibility_age mx-2">{yearsOld}</span>
                      </div>
                      <div className="eligibility_age pt-2">
                        {ageRange?.minimum?.label}
                      </div>
                    </div>
                  </div>
                  <div className="eligibilty-content-2 p-5">
                    <div className="eligibilty-income">
                      <div>
                        <span style={{ fontSize: "48px" }}>
                          {income?.range}
                        </span>
                      </div>
                      <div className="eligibility_income">
                        {income?.description}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default PropertyEligibility;
